import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent {
  @Input() public isLoading: boolean = Boolean(true);
  @Input() public isFullSize: boolean = Boolean(true);
}
